<template>
<div class="rom inner-rombo">
  <div id="color" :class="[shadow && 'shadow', rotate && 'rotate', xsClass, (active && rotate) && 'active-rotate']" :style="colorClass"></div>
  <div id="contenido" :class="[rotate && 'can-hover']" @mouseenter="active = true" @mouseleave="active = false" @focusout="active = false" @focusin="active = true">
    <slot></slot>
  </div>
</div>

</template>

<script>
    export default {
      data () {
        return {
          active: false
        }
      },
      props: {
        rotate: Boolean,
        shadow: Boolean,
        color: {
          default: 'white'
        },
        border: {
          type: Boolean,
          default: false
        }
      },
      computed: {
        xsClass () {
          return this.border ? 'border-class' : ''
        },
        colorClass () {
          return {
            backgroundColor: this.color
          }
        }
      },
      methods: {
      }
    }
</script>

<style lang="scss">

  .rombo-menu {

    #color {
      background-color: #00839E !important;
    }

    &#rombo-blog {

      #color {
        background-color: #F18800 !important;

      }
    }

    &:hover {

      #color {
        background-color: #60bdc5 !important;
      }

      &#rombo-blog {

        #color {
          background-color: #f99c03 !important;

        }
      }
    }
  }

  .rom{
    position: relative;

    &.shadow{
      box-shadow: inset 0px -7px 40px rgba(0, 0, 0, 0.1), 0 0px 10px 5px rgba(0, 0, 0, 0.2);
    }
    #color{
      width: 100%;
      height: 100%;
      position:absolute;
      transform: rotate(45deg);

      &.rotate{
        transition:
          transform 1s,
          background-color 1s;
        &:hover {
          transform: rotate(150deg);
        }
      }

      &.active-rotate {
        transform: rotate(150deg);

      }

    }
    #contenido{
      text-align: center;
      position: absolute;
      width: 100%;
      height: 100%;
      color: #FFFFFF;
      /* top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%); */
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &.can-hover:hover {
        cursor: pointer;
      }
    }

    .border-class{
      border: 5px solid white;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Rombo.vue